import { useDepositModalContent } from "../lib/depositContent.js";
import { lazyOverlay, useLazyOverlay, usePreloadWhenIdle } from "../lib/lazyOverlay.js";
import { useShopper } from "../lib/shopper.js";

const DepositModal = lazyOverlay(() =>
  import("@loot-os/design-system/domain/DepositModal").then((module) => module.DepositModal),
);

/**
 * The Deposit dialog, mounted once around the routes (`App.tsx`): the design system's `DepositModal`
 * filled by `useDepositModalContent`. Anything opens it with `setDepositOpen(true)` or a link to
 * `?deposit=1`; Stripe's checkout return opens it too, with the payment's state. The content (and
 * so the checkout return) runs from the start; the modal's own code loads once it first opens,
 * fetched early for a signed-in shopper, whose header shows Deposit.
 */
export function StoreDeposit() {
  const content = useDepositModalContent();
  usePreloadWhenIdle(DepositModal, !!useShopper().user);
  const Modal = useLazyOverlay(DepositModal, content.open, () => content.onOpenChange(false));
  return Modal && <Modal {...content} />;
}
